
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IChartCriteria, IChartData } from "@tylertech/tyler-api-types";

/**
 * PurchasingChartService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class PurchasingChartService {
    private readonly $apiService = inject(ApiService);
    
    GetOpenPurchaseOrderStatusChartData(criteria: IChartCriteria): Promise<IChartData[]> {
        return this.$apiService.sendAuth("IPurchasingChartService/GetOpenPurchaseOrderStatusChartData", criteria);
    }
}
